import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import styles from './styles/CalendarWeek.module.css';

type Props = {
    children: ReactNode;
    isFirstMonthWeek: boolean;
};

export const CalendarWeek: FC<Props> = ({ children, isFirstMonthWeek }) => {
    return (
        <div
            className={classnames(styles.container, {
                [styles.isFirstMonthWeek]: isFirstMonthWeek,
            })}
        >
            {children}
        </div>
    );
};
